<template>
    <div>
        <b-card>
            <b-card-body>
                <b-media>
                    <!-- 
                        <template #aside>
                            <img class="image-size" src="@/assets/img/iconvehincle.png" alt="MUIC">
                        </template> 
                    -->
                    <h3 class="mt-1 mb-0">Leave Form</h3>
                    <p class="mb-3 mt-0">Sick leave, maternity leave, business leave, vacation</p>
                </b-media>
                <div class="row">
                    <div v-if="dataProfile.length != 0" class="col-sm-12 col-md-4">
                        <div class="mt-4 text-center">
                            <img v-if="imageView !== ''" :src="imageView" class="align-middle img-thumbnail imgAvatar" alt="avatar.png">
                            <img v-else src="@/assets/img/avatar.png"  class="align-middle img-thumbnail imgAvatar"  alt="avatar.png">
                            <b-alert class="text-left mt-3 mb-3" show variant="secondary-custom-absent">
                                <p class="mt-0 mb-2"><strong class="mr-2">Name :</strong>{{ dataProfile[0].title.short_eng }} {{ dataProfile[0].name }} {{ dataProfile[0].surname }}</p>
                                <p class="mt-0 mb-2"><strong class="mr-2">ID :</strong>{{ dataProfile[0].id }}</p>
                                <p class="mt-0 mb-2"><strong class="mr-2">Position :</strong>{{ dataProfile[0].position }}</p>
                                <p class="mt-0 mb-2"><strong class="mr-2">Department :</strong>{{ dataProfile[0].department.name_eng }}</p>
                            </b-alert>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-8">
                        <b-card style="border:1px solid #dadada;">
                            <b-card-body>
                                <label for="textarea" class="text-dark font-weight-bold">Address</label>
                                <b-form-group
                                    id="fieldset-0"
                                    description="address details telephone number who can be contacted"
                                >
                                    <b-form-textarea
                                        id="textarea"
                                        v-model="FormAbsent.address"
                                        placeholder="Enter Address..."
                                        rows="3"
                                        max-rows="6"
                                    ></b-form-textarea>
                                </b-form-group>
                                <label class="text-dark font-weight-bold">Type</label>
                                <b-form-group v-slot="{ ariaDescribedby }">
                                    <b-form-select id="select-1" :aria-describedby="ariaDescribedby" v-model="FormAbsent.type" :options="optionsType"></b-form-select>
                                </b-form-group>
                                <label for="input-1" class="text-dark font-weight-bold">Detail</label>
                                <b-form-group
                                    id="fieldset-1"
                                    description="leave details"
                                >
                                    <b-form-input type="text" id="input-1" placeholder="Detail..." v-model="FormAbsent.detail"></b-form-input>
                                </b-form-group>
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="textarea" class="text-dark font-weight-bold">Start</label>
                                        <b-form-group
                                            id="fieldset-2"
                                        >
                                            <b-form-input type="date" id="input-2" v-model="FormAbsent.startDate"></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="textarea" class="text-dark font-weight-bold">End</label>
                                        <b-form-group
                                            id="fieldset-2"
                                        >
                                            <b-form-input type="date" id="input-2" v-model="FormAbsent.endDate"></b-form-input>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-input-group prepend="Total" append="Days">
                                            <b-form-input class="text-right" type="number" v-model="FormAbsent.amount"></b-form-input>
                                        </b-input-group>
                                    </div>
                                </div>
                                <!-- term & condition -->
                                <hr class="mt-2 mb-3" >
                                <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="FormAbsent.status"
                                    name="checkbox-1"
                                    value="accepted"
                                    unchecked-value="not_accepted"
                                >
                                    <span class="text-danger font-weight-bold">I have already checked the information.</span>
                                </b-form-checkbox>
                                <div class="mb-3 mt-2">
                                    <b-button @click="submitFormAbsent" size="sm" class="text-capitalize mr-3" variant="success">Submit & Print (.pdf)</b-button>
                                    <b-button @click="cancel" size="sm" class="text-capitalize" variant="danger">Cancel</b-button>
                                </div>
                            </b-card-body>
                        </b-card>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import pdfMake from 'pdfmake';
import htmlToPdfmake from "html-to-pdfmake";
const formAbsent = {
    type:null,
    startDate: null,
    endDate: null,
    amount: null,
    detail:null,
    address:null,
    status:'not_accepted'
}
export default {
    data(){
        return{
            FormAbsent: Object.assign({}, formAbsent),
            dataProfile: [],
            urlPic: null,
            imageView: '',
            optionsType: [
                { text: 'Please select type leave', value: null },
                { text: 'Sick', value: 'sick' },
                { text: 'Medical', value: 'medical' },
                { text: 'Casual', value: 'casual' },
                { text: 'Vacation', value: 'vacation' },
                { text: 'Maternity', value: 'maternity' },
                { text: 'Monkhood', value: 'monkhood' },
                { text: 'Extra', value: 'extra' },
                { text: 'Other', value: 'other' },
            ]
        }
    },
    mounted(){
        this.getPhotoAvatar()
        this.getProfile()
    },
    methods:{
        async getProfile(){
            this.dataProfile = []
            try {
                const res = await this.$http.get(`/staff/profile/me/`)
                if(res.status === 200){
                    this.dataProfile.push(res.data)
                }
            } catch (error) {}
        },
        ImageProfile(val) { return val !== null && val !== 'null' ? val : `@/assets/img/avatar.png` },
        async getPhotoAvatar(){
            try {
                const res = this.$http.get(`/portal/profile/get_img/`,{ 'responseType': 'blob' }).then((res) => {
                    if(res.status === 200){
                        let blob = new Blob([res.data])
                        return this.imageView = this.ImageProfile(window.URL.createObjectURL(blob))
                    }else{
                        throw { res }
                    }
                })
            } catch (error) {
                return this.imageView = ''
            }
        },
        cancel(){
            this.$router.push({
                path:"/leaveofabsent",
            }).catch(err => {})
        },
        async submitFormAbsent(){
            const sendDataLeave = new FormData()
            sendDataLeave.append('user', this.dataProfile[0].id)
            sendDataLeave.append('address', this.FormAbsent.address)
            sendDataLeave.append('detail', this.FormAbsent.detail)
            sendDataLeave.append('absence_type', this.FormAbsent.type)
            sendDataLeave.append('start_date', this.FormAbsent.startDate)
            sendDataLeave.append('end_date', this.FormAbsent.endDate)
            sendDataLeave.append('absence_amount', this.FormAbsent.amount)
            try {
                const response = await this.$http.post('/hri/leave_of_absence/', sendDataLeave,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                if(response.status === 201){
                    this.exportFile()
                    this.FormAbsent = Object.assign({}, formAbsent)
                }else{
                    throw { response }
                }
            } catch (error) {}
        },
        exportFile () {
            let a = `<p>xxxxxxxxx</p>`
            let htmlContent = htmlToPdfmake(a)
            const docDefinition = {
                content: htmlContent
            }
            pdfMake.fonts = {
                // download default Roboto font from cdnjs.com
                Roboto: {
                    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
                }
            }
            // pdfMake.createPdf(docDefinition).print({}, win)
            const pdfDocGenerator = pdfMake.createPdf(docDefinition);
            pdfDocGenerator.getBlob((blob) => {
                let link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                window.open(link.href, '_blank');
            });
        }
    }
}
</script>

<style scoped>
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .imgAvatar{ width: 120px; height: 120px; }
    .alert-secondary-custom-absent {
        color: #000000;
        background-color: #e8e9ea;
        border-color: #d6d8db;
    }
</style>